export default "__VITE_ASSET__c6548555__"